import { useDispatch } from 'react-redux';
import { toogleToast } from 'reducers/misc';

export function useToastMessage() {
  const dispatch = useDispatch();
  const windowGlobal = typeof window !== 'undefined';

  return (message: string) => {
    dispatch(toogleToast({ open: true, message: message }));

    windowGlobal &&
      window.setTimeout(() => {
        dispatch(toogleToast({ open: true, message: '' }));
      }, 3500);

    windowGlobal &&
      window.setTimeout(() => {
        dispatch(toogleToast({ open: false, message: '' }));
      }, 3600);
  };
}

export function useToast(message: string) {
  const showToast = useToastMessage();

  return () => showToast(message);
}
